import { useEffect, useCallback } from "react";

const DRAFT_KEY = "hirfati_draft_annonce";

export interface DraftAnnonceData {
  title: string;
  category: string;
  urgency: string;
  wilaya: string;
  commune: string;
  addressHint: string;
  description: string;
  budgetMin: string;
  budgetMax: string;
}

export const saveDraft = (data: DraftAnnonceData) => {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(data));
  } catch {
    // localStorage full or unavailable
  }
};

export const loadDraft = (): DraftAnnonceData | null => {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearDraft = () => {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    // ignore
  }
};

export const useDraftAutosave = (data: DraftAnnonceData) => {
  useEffect(() => {
    // Only save if there's meaningful data
    const hasData = data.title || data.category || data.description;
    if (hasData) {
      saveDraft(data);
    }
  }, [data]);
};
